module.exports = __webpack_public_path__ + "img/hic-genitourinary-diseases-female.56ed53e7.png";